import { render, staticRenderFns } from "./doctorMaster.vue?vue&type=template&id=0681b862&"
import script from "./doctorMaster.vue?vue&type=script&lang=js&"
export * from "./doctorMaster.vue?vue&type=script&lang=js&"
import style0 from "./doctorMaster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports